const NAMES = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
export const midiName = (m) => `${NAMES[m % 12]}${Math.floor(m / 12) - 1}`;
export const freqToMidi = (f) => Math.round(69 + 12 * Math.log2(f / 440));

export async function openMic() {
  const stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: false, noiseSuppression: false, autoGainControl: false } });
  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  const src = ctx.createMediaStreamSource(stream);
  const analyser = ctx.createAnalyser();
  analyser.fftSize = 2048;
  src.connect(analyser);
  const buf = new Float32Array(analyser.fftSize);
  const read = () => { analyser.getFloatTimeDomainData(buf); return buf; };
  const stop = () => { stream.getTracks().forEach((t) => t.stop()); ctx.close().catch(() => {}); };
  return { ctx, read, stop };
}

export const rms = (b) => { let s = 0; for (let i = 0; i < b.length; i += 1) s += b[i] * b[i]; return Math.sqrt(s / b.length); };

// Autocorrelation pitch detection; returns Hz or null.
export function detectPitch(b, sampleRate) {
  if (rms(b) < 0.012) return null;
  const n = b.length;
  const minLag = Math.floor(sampleRate / 1200), maxLag = Math.floor(sampleRate / 70);
  let best = -1, bestLag = -1;
  const c0 = b.reduce((a, v) => a + v * v, 0);
  for (let lag = minLag; lag <= maxLag; lag += 1) {
    let s = 0;
    for (let i = 0; i < n - lag; i += 1) s += b[i] * b[i + lag];
    s /= c0;
    if (s > best) { best = s; bestLag = lag; }
  }
  if (best < 0.85 || bestLag < 0) return null;
  let lag = bestLag;
  for (const div of [4, 3, 2]) {
    const l = Math.round(bestLag / div);
    if (l < minLag) continue;
    let s = 0;
    for (let i = 0; i < n - l; i += 1) s += b[i] * b[i + l];
    if (s / c0 > best * 0.92) { lag = l; break; }
  }
  return sampleRate / lag;
}
